
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/south-park-character-generator",
      function () {
        return require("private-next-pages/south-park-character-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/south-park-character-generator"])
      });
    }
  